import { Loader, Overlay } from '@mantine/core';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { Show } from '../../../../react-commons/components/control-flow/Show';
import { RootState } from '../../store/rootReducer';

const useStyles = makeStyles()((_) => ({
    parent: {
        position: 'relative',
        width: '100%',
        height: '100%',
        backgroundColor: 'var(--mantine-color-body)',
        zIndex: 0,
    },
    parentWithOpen: {
        position: 'relative',
        width: '100%',
        height: '100%',
        backgroundColor: 'var(--mantine-color-body)',
        zIndex: 9999,
    },
}));

export const LoadingComponent= ({ open }: {
    open?: boolean;
}) => {
    const classes = useStyles();

    const globalSpinnerOpen = useSelector((state: RootState) => {
        if (open !== undefined) {
            return open;
        }
        return state.persisted.global.openSpinner;
    });

    return (
        <div className={open === undefined ? classes.classes.parent : classes.classes.parentWithOpen}>
            <Show when={globalSpinnerOpen}>
                <Overlay>
                    <Loader
                        pos={'absolute'}
                        top={'50%'}
                        left={'50%'}
                        color={'primaryTeal.6'}
                        style={{ transform: 'translate(-50%, -50%)' }}
                    />
                </Overlay>
            </Show>
        </div>
    );
};


